import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import arTranslation from "./locales/ar/translation";
import bnTranslation from "./locales/bn/translation";
import deTranslation from "./locales/de/translation";
import enTranslation from "./locales/en/translation";
import esTranslation from "./locales/es/translation";
import frTranslation from "./locales/fr/translation";
import hiTranslation from "./locales/hi/translation";
import idTranslation from "./locales/id/translation";
import itTranslation from "./locales/it/translation";
import jaTranslation from "./locales/ja/translation";
import koTranslation from "./locales/ko/translation";
import mnTranslation from "./locales/mn/translation";
import ptTranslation from "./locales/pt/translation";
import ptBRTranslation from "./locales/pt-BR/translation";
import ruTranslation from "./locales/ru/translation";
import thTranslation from "./locales/th/translation";
import tlTranslation from "./locales/tl/translation";
import ukTranslation from "./locales/uk/translation";
import viTranslation from "./locales/vi/translation";
import zhTranslation from "./locales/zh/translation";
import zhTWTranslation from "./locales/zh-TW/translation";
import { homeModuleTranslations } from "./locales/homeModuleTranslations";
import { lukkeyBaseTranslation } from "./locales/lukkeyBase";
import { lukkeyFaqOverrides } from "./locales/lukkeyFaqOverrides";
import { lukkeyModuleTranslations } from "./locales/lukkeyModuleTranslations";
import { lukkeyPricingTranslations } from "./locales/lukkeyPricingTranslations";
import { lukkeyLocalizedTranslations } from "./locales/lukkeyTranslations";
import { legalUiTranslations } from "./locales/legalUiTranslations";
import { mediaKitTranslations } from "./locales/mediaKitTranslations";
import { partnerTranslations } from "./locales/partnerTranslations";
import { siteModuleTranslations } from "./locales/siteModuleTranslations";
import { DEFAULT_LOCALE, getLocaleFromPathname } from "./utils/localeRouting";

//en zh zh-TW fr es ar ja ru ko pt pt-BR it de hi mn th uk vi id tl bn

const initialLng = (() => {
  if (typeof window !== "undefined") {
    const localeFromPath = getLocaleFromPathname(window.location.pathname);
    if (localeFromPath) return localeFromPath;
  }
  return DEFAULT_LOCALE;
})();

const withLukkeyTranslations = (lang, translation) => ({
  ...lukkeyBaseTranslation,
  ...translation,
  ...(homeModuleTranslations[lang] || {}),
  ...(lukkeyLocalizedTranslations[lang] || {}),
  ...(lukkeyPricingTranslations[lang] || {}),
  ...(lukkeyFaqOverrides[lang] || {}),
  ...(lukkeyModuleTranslations[lang] || {}),
  ...(legalUiTranslations[lang] || {}),
  ...(mediaKitTranslations[lang] || {}),
  ...(partnerTranslations[lang] || {}),
  ...(siteModuleTranslations[lang] || {}),
});

i18n
  .use(initReactI18next) // 绑定到 react-i18next
  .init({
    resources: {
      en: { translation: withLukkeyTranslations("en", enTranslation) },
      zh: { translation: withLukkeyTranslations("zh", zhTranslation) },
      "zh-TW": {
        translation: withLukkeyTranslations("zh-TW", zhTWTranslation),
      },
      fr: { translation: withLukkeyTranslations("fr", frTranslation) },
      es: { translation: withLukkeyTranslations("es", esTranslation) },
      ar: { translation: withLukkeyTranslations("ar", arTranslation) },
      ja: { translation: withLukkeyTranslations("ja", jaTranslation) },
      ru: { translation: withLukkeyTranslations("ru", ruTranslation) },
      ko: { translation: withLukkeyTranslations("ko", koTranslation) },
      pt: { translation: withLukkeyTranslations("pt", ptTranslation) },
      "pt-BR": {
        translation: withLukkeyTranslations("pt-BR", ptBRTranslation),
      },
      it: { translation: withLukkeyTranslations("it", itTranslation) },
      de: { translation: withLukkeyTranslations("de", deTranslation) },
      hi: { translation: withLukkeyTranslations("hi", hiTranslation) },
      mn: { translation: withLukkeyTranslations("mn", mnTranslation) },
      th: { translation: withLukkeyTranslations("th", thTranslation) },
      uk: { translation: withLukkeyTranslations("uk", ukTranslation) },
      vi: { translation: withLukkeyTranslations("vi", viTranslation) },
      id: { translation: withLukkeyTranslations("id", idTranslation) },
      tl: { translation: withLukkeyTranslations("tl", tlTranslation) },
      bn: { translation: withLukkeyTranslations("bn", bnTranslation) },
    },
    lng: initialLng,
    fallbackLng: DEFAULT_LOCALE,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
